import Queue from "nq-js";

class GetAllSchemasUseCase {
  execute() {
    return new Queue.Schema().find();
  }
}

export default GetAllSchemasUseCase;
